export const DEPARTMENT_SEGMENTS = ["a", "b", "c"]
